import React, { memo, ReactEventHandler } from 'react';
import Animate from 'rc-animate';
import classNames from 'classnames';
import './secondaryExamPoint.less';
import { SecondaryExamPointsCollapseIcon } from '@/svgs';
import ChildExamPoint from './ChildExamPoint';
import { IHomePageExamSyllabusContentItem } from '@/types';
import { useCollapseContext } from '../../context/CollapseContext';

interface IProps {
    data: IHomePageExamSyllabusContentItem;
}

const SecondaryExamPoint = (props: IProps) => {
    const { data } = props;

    const { collapseState, dispatch } = useCollapseContext();
    const isCollapsed = collapseState[data.contentId] ?? false; // 默认未折叠
    const collapsible = !!data.contentChildren?.length; // 是否可折叠
    const handleChangeCollapse: ReactEventHandler<HTMLElement> = event => {
        event.persist();
        if (!collapsible) {
            event.stopPropagation();
            return;
        }
        let target = event.target as HTMLElement; // 解决typescript eventTarget dataset报错
        let isStop = target.dataset.event === 'false';
        while (target && !isStop) {
            if (target.dataset?.event === 'false') {
                isStop = true;
            }
            target = target.parentNode as HTMLElement;
        }
        if (isStop) {
            event.stopPropagation();
            return;
        }
        dispatch({ type: 'TOGGLE_COLLAPSE', id: data.contentId });
    };

    return (
        <div
            className={classNames('sub-tiku__exam-point', 'sub-tiku__secondary-exam-point', {
                'sub-tiku__exam-point-collapse-active': isCollapsed,
            })}
        >
            <div
                className="sub-tiku__exam-point-main"
                style={{ cursor: collapsible ? 'pointer' : 'default' }}
                onClick={handleChangeCollapse}
            >
                <div className="sub-tiku__exam-point-meta">
                    <div className="sub-tiku__exam-point-meta-prefix">
                        {collapsible ? (
                            <SecondaryExamPointsCollapseIcon
                                className="sub-tiku__exam-point-collapse-icon"
                                rotate={isCollapsed ? 0 : 180}
                            />
                        ) : null}
                    </div>
                    <div className="sub-tiku__exam-point-meta-content">
                        <div className="sub-tiku__exam-point-meta-title">
                            <span>{data.title}</span>
                        </div>
                    </div>
                </div>
            </div>
            {!!data.contentChildren?.length && (
                <Animate transitionAppear={false} component="" transitionName="collapse-animation">
                    {isCollapsed ? (
                        <div className="sub-tiku__exam-point-children">
                            {data.contentChildren.map((item, index) => (
                                <ChildExamPoint
                                    key={`sub-tiku__exam-point-${item.contentId}`}
                                    data={item}
                                    isShowIconLine={{
                                        prefix: index !== data.contentChildren.length - 1,
                                        suffix: index !== 0,
                                    }}
                                />
                            ))}
                        </div>
                    ) : null}
                </Animate>
            )}
        </div>
    );
};

export default memo(SecondaryExamPoint);
